import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getBackgroundImage } from "../../../section/utils/get-background-image"
import { compact } from "core/utils"
import { getBorderStyle } from "app/regions/blocks/utils"

export function SingleColumn({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = compact({
    backgroundColor: properties.backgroundColor,
    backgroundImage: getBackgroundImage(properties),
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTop: getBorderStyle(
      properties.borderTopWidth,
      properties.borderColor
    ),
    borderRight: getBorderStyle(
      properties.borderRightWidth,
      properties.borderColor
    ),
    borderBottom: getBorderStyle(
      properties.borderBottomWidth,
      properties.borderColor
    ),
    borderLeft: getBorderStyle(
      properties.borderLeftWidth,
      properties.borderColor
    )
  })

  // Outlook has buggy padding handling, unless on table cells
  const cellStyle = compact({
    paddingLeft: properties.horizontalPadding,
    paddingRight: properties.horizontalPadding,
    paddingTop: properties.verticalPadding,
    paddingBottom: properties.verticalPadding,
    verticalAlign: "middle"
  })

  return (
    <div style={containerStyle} bgcolor={properties.backgroundColor}>
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td style={cellStyle}>
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
